import styled, { keyframes } from "styled-components";

import { media } from "../../../../../styles/media";

// Gentle entrance so collapsing the checklist to the bar isn't a hard cut.
const collapseIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const MinimizedBarStyles = styled.div`
  width: 100%;
  max-width: 960px;
  background: ${({ theme }) => theme.colors.semantic.container.white};
  box-shadow: ${({ theme }) => theme.shadows.card};
  border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
  border-radius: ${({ theme }) => theme.radius[12]};
  padding: 14px 20px;
  display: flex;
  align-items: center;
  gap: 18px;
  cursor: pointer;
  animation: ${collapseIn} 0.28s ease both;

  .ob-min-badge {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.accent[50]};
    color: ${({ theme }) => theme.colors.semantic.accent.default};
    display: grid;
    place-items: center;
    flex-shrink: 0;
  }

  .ob-min-main {
    flex: 1;
    min-width: 0;
  }

  .ob-min-title {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .ob-min-progress {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 7px;
  }

  .ob-min-track {
    flex: 1;
    max-width: 260px;
    height: 6px;
    border-radius: ${({ theme }) => theme.radius.rounded};
    background: ${({ theme }) => theme.colors.primary[100]};
    overflow: hidden;
  }

  .ob-min-fill {
    height: 100%;
    background: ${({ theme }) => theme.colors.semantic.accent.default};
    transition: width 0.5s ease;
  }

  .ob-min-count {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary[500]};
    white-space: nowrap;
  }

  .ob-min-chevron {
    color: ${({ theme }) => theme.colors.primary[300]};
    display: flex;
    transform: rotate(-90deg);
    flex-shrink: 0;
  }

  ${media.maxMobile`
    flex-wrap: wrap;
    gap: 12px;
  `}
`;
